import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

/**
 * Home component for the tkw dashboard.
 *
 * The dashboard has no real home view; admins should land directly on the
 * user grid. This component does nothing but redirect to the ums user grid
 * route. It is registered as the home component via LayoutService.setHomeComponent().
 */
@Component({
  selector: 'app-user-grid-redirect',
  template: ''
})
export class UserGridRedirectComponent implements OnInit {
  public constructor(private router: Router) {
  }

  public ngOnInit(): void {
    this.router.navigateByUrl('/module/ums/user/grid');
  }
}
